import config from '../../config';
import { getAuthHeaders, handleNoContentResponse, handleResponse } from './common';

const ENDPOINT = `${config.api.url}/practice-extensions/prenatal-visit/review`;

const practiceExtensionsApi = {
  getPrenatalReviewCatalog: async () => {
    const res = await fetch(ENDPOINT, {
      headers: getAuthHeaders(),
    });
    return handleResponse(res);
  },

  updatePrenatalReviewNoteOverrides: async (overrides) => {
    const res = await fetch(`${ENDPOINT}/note-overrides`, {
      method: 'PUT',
      headers: getAuthHeaders(),
      body: JSON.stringify({ overrides }),
    });
    return handleResponse(res);
  },

  createPrenatalReviewField: async (field) => {
    const res = await fetch(`${ENDPOINT}/fields`, {
      method: 'POST',
      headers: getAuthHeaders(),
      body: JSON.stringify(field),
    });
    return handleResponse(res);
  },

  updatePrenatalReviewField: async (referenceId, field) => {
    const res = await fetch(`${ENDPOINT}/fields/${referenceId}`, {
      method: 'PUT',
      headers: getAuthHeaders(),
      body: JSON.stringify(field),
    });
    return handleResponse(res);
  },

  deactivatePrenatalReviewField: async (referenceId) => {
    const res = await fetch(`${ENDPOINT}/fields/${referenceId}`, {
      method: 'DELETE',
      headers: getAuthHeaders(),
    });
    return handleNoContentResponse(res);
  },

  getBirthOverrideNotificationTemplate: async () => {
    const res = await fetch(`${ENDPOINT}/birth-override-notification`, {
      headers: getAuthHeaders(),
    });
    return handleResponse(res);
  },

  updateBirthOverrideNotificationTemplate: async (template) => {
    const res = await fetch(`${ENDPOINT}/birth-override-notification`, {
      method: 'PUT',
      headers: getAuthHeaders(),
      body: JSON.stringify(template),
    });
    return handleResponse(res);
  },
};

export default practiceExtensionsApi;
